// extracted by mini-css-extract-plugin
module.exports = {"root":"Completed_root__3Jbfh","label":"Completed_label__2HP6w"};